/** QR payment popup helpers (ported from SmartBillWithQR). */

export const QR_INITIAL_DURATION = 150;

export const formatQrTimer = (value) => {
  const safeValue = Math.max(0, Number(value) || 0);
  const minutes = Math.floor(safeValue / 60);
  const seconds = safeValue % 60;
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
};

export const buildQrPopupHtml = (data, timer, isRegenerated) => {
  const servicesList = (data?.servicesList || [])
    .map(
      (service) =>
        `<li class="qr-popup-service-item"><span>${service.index}.</span><span>${service.name}</span></li>`,
    )
    .join('') || '<li class="qr-popup-service-item"><span>1.</span><span>Student course fees</span></li>';

  const regenerateBadge = isRegenerated
    ? '<div class="qr-popup-notice">🔄 QR regenerated. Ask customer to scan again.</div>'
    : '';

  return `
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="UTF-8" />
          <title>KNLS Payment QR</title>
          <style>
            body { font-family: 'Inter', Arial, sans-serif; margin: 0; padding: 24px; background: #f0f4ff; color: #1f2937; }
            .qr-wrapper { max-width: 480px; margin: 0 auto; background: #ffffff; border-radius: 18px; box-shadow: 0 20px 60px rgba(15, 23, 42, 0.15); padding: 24px; border: 1px solid #e5e7eb; }
            h1 { margin: 0 0 8px; font-size: 20px; color: #0f172a; }
            .subtitle { font-size: 13px; color: #64748b; margin-bottom: 16px; }
            .info-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; margin-bottom: 16px; }
            .info-card { background: #f8fafc; border-radius: 10px; padding: 12px; border: 1px solid #e2e8f0; }
            .qr-popup-services { margin: 16px 0; border: 1px dashed #cbd5f5; border-radius: 12px; background: #f9fbff; padding: 12px; }
            .qr-popup-services-title { font-size: 13px; font-weight: 600; color: #475569; margin-bottom: 8px; }
            .qr-popup-service-item { list-style: none; display: flex; gap: 10px; padding: 6px 0; border-bottom: 1px solid #e2e8f0; font-size: 14px; }
            .qr-popup-service-item:last-child { border-bottom: none; }
            .qr-image { display: block; margin: 20px auto; width: 220px; height: 220px; border-radius: 16px; border: 6px solid #eef2ff; box-shadow: 0 15px 40px rgba(59, 130, 246, 0.25); }
            .amount-box { text-align: center; margin: 16px 0; }
            .amount-box div:first-child { font-size: 13px; color: #64748b; }
            .amount-box div:last-child { font-size: 32px; font-weight: 700; color: #0f172a; }
            .timer { display: flex; flex-direction: column; align-items: center; gap: 4px; padding: 12px; border-radius: 12px; background: #fef3c7; border: 1px solid #fcd34d; font-weight: 600; }
            .timer span { font-size: 22px; }
            .qr-popup-notice { margin-top: 12px; padding: 10px 14px; border-radius: 10px; background: #fef2f2; border: 1px solid #fecaca; color: #b91c1c; font-size: 13px; }
            .qr-actions { display: flex; flex-direction: column; gap: 10px; margin-top: 22px; }
            .qr-btn { padding: 12px 16px; border-radius: 10px; border: none; font-weight: 600; font-size: 15px; cursor: pointer; display: flex; justify-content: center; gap: 8px; }
            .qr-btn.print { background: #e0e7ff; color: #312e81; }
            .qr-btn.close { background: #f1f5f9; color: #475569; }
            .manual-payment { margin-top: 16px; font-size: 13px; color: #475569; text-align: center; }
          </style>
        </head>
        <body>
          <div class="qr-wrapper">
            <h1>🏦 KNLS Payment Request</h1>
            <div class="subtitle">Generated at ${data?.timestamp || ''}</div>
            <div class="info-grid">
              <motionless class="info-card">
                <div style="font-size:12px;color:#94a3b8;">Customer</div>
                <div style="font-weight:600;">${data?.name || 'Unknown'}</div>
                <div style="font-size:12px;color:#475569;">${data?.phone || ''}</div>
              </motionless>
              <div class="info-card">
                <div style="font-size:12px;color:#94a3b8;">UPI ID</div>
                <div style="font-weight:600;">${data?.upiId || ''}</div>
              </div>
            </div>
            <div class="qr-popup-services">
              <div class="qr-popup-services-title">Courses / Services</div>
              <ul style="margin:0;padding:0;">${servicesList}</ul>
            </div>
            ${regenerateBadge}
            <div class="amount-box">
              <div>Amount to pay</div>
              <motionless>₹${data?.amount || '0'}</div>
            </div>
            <img src="${data?.qrCodeUrl}" alt="Payment QR Code" class="qr-image" />
            <div class="timer">
              <div>QR valid for</div>
              <span id="qr-countdown">${formatQrTimer(timer)}</span>
            </div>
            <div class="manual-payment">Manual Payment: ${data?.upiId || ''}</div>
            <div class="qr-actions">
              <button class="qr-btn print" onclick="window.print()">🖨️ Print</button>
              <button class="qr-btn close" onclick="window.close()">✖ Close Window</button>
            </div>
          </div>
        </body>
      </html>
    `
    .replace(/<motionless/g, '<div')
    .replace(/<\/motionless>/g, '</div>');
};

export const openQrPopupWindow = (popupRef, onClose) => {
  if (typeof window === 'undefined') return null;

  if (popupRef.current && !popupRef.current.closed) {
    popupRef.current.focus();
    return popupRef.current;
  }

  const popup = window.open('', 'locsyQrWindow', 'width=520,height=760,scrollbars=yes');
  if (!popup) {
    return null;
  }

  popup.document.write(
    '<!DOCTYPE html><html><head><title>Loading QR...</title></head><body style="font-family:Arial;padding:24px;">Preparing QR...</body></html>',
  );
  popup.document.close();
  popup.onbeforeunload = () => {
    onClose?.();
    popupRef.current = null;
  };
  popupRef.current = popup;
  return popup;
};

export const renderQrPopupContent = (popupRef, data, timer, isRegenerated) => {
  const popup = popupRef.current && !popupRef.current.closed ? popupRef.current : null;
  if (!popup) return false;
  const doc = popup.document;
  doc.open();
  doc.write(buildQrPopupHtml(data, timer, isRegenerated));
  doc.close();
  return true;
};
